import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaRocket, FaShieldAlt, FaClock, FaPercent } from 'react-icons/fa';

const HeroCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      title: "Get Your Dream Loan Today",
      subtitle: "Fast, Secure & Reliable",
      description: "Experience lightning-fast loan approval with our AI-powered assessment system. Get approved within 24 hours.",
      ctaText: "Apply Now",
      ctaLink: "/apply",
      icon: <FaRocket />,
      bgGradient: "linear-gradient(135deg, #002F6C 0%, #004B9F 50%, #0066CC 100%)"
    },
    {
      id: 2,
      title: "Bank-Level Security",
      subtitle: "Your Data is Protected",
      description: "Advanced 256-bit encryption and multi-layer security protocols ensure your personal information stays safe.",
      ctaText: "Learn More",
      ctaLink: "/about",
      icon: <FaShieldAlt />,
      bgGradient: "linear-gradient(135deg, #004B9F 0%, #0066CC 50%, #0080FF 100%)"
    },
    {
      id: 3,
      title: "Competitive Interest Rates",
      subtitle: "Starting from 7.3% APR ",
      description: "Enjoy premium rates with flexible repayment options tailored to your financial goals and capabilities.",      additionalText: "✓ Transparent Loan Process",      ctaText: "Check Rates",
      ctaLink: "/services",
      icon: <FaPercent />,
      bgGradient: "linear-gradient(135deg, #0066CC 0%, #0080FF 50%, #00A0FF 100%)"
    },
    {
      id: 4,
      title: "Quick Processing",
      subtitle: "Same Day Approval",
      description: "Our streamlined process ensures quick turnaround times without compromising on thorough evaluation.",
      ctaText: "Get Started",
      ctaLink: "/apply",
      icon: <FaClock />,
      bgGradient: "linear-gradient(135deg, #002F6C 0%, #0066CC 50%, #004B9F 100%)"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <div className="hero-carousel">
      <div className="carousel-container">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ background: slide.bgGradient }}
          >
            <div className="slide-content">
              <div className="slide-icon">
                {slide.icon}
              </div>
              <h1 className="slide-title">{slide.title}</h1>
              <h2 className="slide-subtitle">{slide.subtitle}</h2>
              <p className="slide-description">{slide.description}</p>
              {slide.additionalText && (
                <p className="slide-additional-text">{slide.additionalText}</p>
              )}
              <Link to={slide.ctaLink} className="slide-cta">
                {slide.ctaText}
              </Link>
            </div>
            <div className="slide-overlay"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HeroCarousel;